import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'
import UdcTabbedSelect from '@/components/common/UdcTabbedSelect.vue'
import { useInitDataStore } from '@/stores/initDataStore'


export default /*#__PURE__*/_defineComponent({
  emits: ['select'],
  setup(__props, { emit }) {


const initDataStore = useInitDataStore()

const definitionInfo = computed(() => {
  return initDataStore.initData.definitionInfo?.graph.common.listItems
})

const tabs = computed(() => {
  return definitionInfo.value.items
})

const select = ({ tabIndex, listItemIndex, itemIndex }) => {
  const item = tabs.value[tabIndex].items[listItemIndex].items[itemIndex]

  emit('select', item)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UdcTabbedSelect, {
    onSelect: select,
    title: _unref(definitionInfo).title,
    tabs: _unref(tabs)
  }, null, 8, ["title", "tabs"]))
}
}

})